// React Components
import React from "react";

// Material UI Components
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

// Audit Vault Constants
import {REPORT_PERIOD_LIST} from "../../constants/constants-reportperiods";


// Function to insert our tenant dropdown list (textfield).
export default function PeriodDropDown(props){

    const { selectedPeriodOption, 
        handlePeriodOptionChange} = props;

    return(
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'stretch', sm: 'center' }, gap: 1.5 }}>
        <Typography component="label" htmlFor="period-select" sx={{ fontWeight: 600, minWidth: 88 }}>View past:</Typography>
            <TextField
                    required
                    select
                    id="period-select"
                    value={selectedPeriodOption}
                    onChange={handlePeriodOptionChange}
                    helperText=""
                    variant="outlined"
                    size="small"
                    sx={{ width: { xs: '100%', sm: 144 } }}
                    InputLabelProps={{ shrink: true }}
                >
                    {REPORT_PERIOD_LIST && REPORT_PERIOD_LIST.map((period) => (
                        <MenuItem key={period.id} value={period}>
                            {period.label}
                        </MenuItem>
                    ))}
                </TextField>
    </Box>)
};
